// extracted by mini-css-extract-plugin
export var accordionContent = "Accordion-mps-module--accordionContent--9b900";
export var accordionHeader = "Accordion-mps-module--accordionHeader--0745b";
export var accordionRoot = "Accordion-mps-module--accordionRoot--789b8";
export var hide = "Accordion-mps-module--hide--7cfbd";
export var iconContainer = "Accordion-mps-module--iconContainer--0036b";
export var rotate = "Accordion-mps-module--rotate--b52c3";
export var show = "Accordion-mps-module--show--f5c28";
export var uppercase = "Accordion-mps-module--uppercase--30e56";